<h1>De Cifris Scholarships</h1>

<div class="intro-context">
  <p>
    Di seguito elenchiamo i corsi di laurea e i curriculum che De Cifris ha selezionato autonomamente come interessanti per poter approfondire le proprie competenze crittografiche. 
    <strong>Ricordiamo che non sono coinvolte le università citate, né lo sono i dipartimenti e i corsi di laurea, in quanto la borsa è unicamente un rapporto di natura privata tra De Cifris e gli studenti vincitori del bando.</strong> 
    In particolare, l'eventuale l'ammissione a uno di questi percorsi universitari è dovuta unicamente al rapporto tra studenti e ateneo.
  </p>
</div>

<div class="bandi-ufficiali">
  <p>Bando di Concorso: <a href="https://drive.google.com/file/d/1Tk8rqcqksU2jBOG3z6XmMi5RrucrbDFU/view?usp=sharing" target="_blank">Laurea Magistrale in Matematica</a></p>
  <p>Vincitore Bando di Matematica: Jacopo Elefante</p>
  <p>Bando di Concorso: <a href="https://drive.google.com/file/d/1KkB-GRPKP8jty_lH6Li2jasigE4coPb1/view?usp=sharing" target="_blank">Laurea Magistrale in Informatica</a></p>
  <p>Vincitore Bando di Informatica: Marina Inglese</p>
</div>

<hr>

<ul class="lista-atenei">
  <li>
    <strong>Università di Trento</strong>: Laurea Magistrale in Matematica (curriculum Cryptography). 
    Tematiche: crittografia post-quantum; crittografia omomorfa, funzionale e Cloud Encryption; protocolli di MPC. 
  </li>

  <li>
    <strong>Università di Genova</strong>: Laurea Magistrale in Matematica (curriculum generale). 
    Tematiche: crittografia post-quantum. 
  </li>

  <li>
    <strong>Università di Perugia</strong>: Laurea Magistrale in Matematica (curriculum “Matematica per la crittografia”). 
    Tematiche: Cloud encryption (cifratura omomorfa, funzionale, ecc.). 
  </li>

  <li>
    <strong>Università di Napoli</strong>: Laurea Magistrale in Matematica (curriculum generale). 
    Tematiche: Teoria dei Codici. 
  </li>

  <li>
    <strong>Università della Campania</strong>: Laurea Magistrale in Matematica (curriculum generale). 
    Tematiche: crittografia post-quantum; Teoria dei Codici. 
  </li>

  <li>
    <strong>Università dell'Aquila</strong>: Laurea Magistrale in Matematica (percorso Algebra e Geometria). 
    Tematiche: design di primitive crittografiche; sicurezza ICT. 
  </li>

  <li>
    <strong>Università di Bari</strong>: Laurea Magistrale in Matematica (Orientamento Generale e Applicata). 
    Tematiche: crittografia e IA; crittografia e Quantum Computing. 
  </li>

  <li>
    <strong>Università di Roma Tre</strong>: Scienze Computazionali (Curriculum Crittografia e Sicurezza). 
    Tematiche: crittografia per il cloud; post-quantum (LWE); crittoanalisi simmetrica (IoT). 
  </li>

  <li>
    <strong>Università di Milano</strong>: Laurea Magistrale in Informatica. 
    Tematiche: crittografia e intelligenza artificiale; crittografia simmetrica. 
  </li>

  <li>
    <strong>Università di Torino</strong>: Laurea Magistrale in Informatica. 
    Tematiche: Applicazioni decentralizzate e blockchain; tokenomics. 
  </li>
</ul>

<p style="margin-top: 20px;">
  Per saperne di più: <a href="https://drive.google.com/file/d/1FFZQqblL4K5Rf9k60-Cht0SHX75Gwriv" target="_blank">vecchie slides di presentazione</a> per De Cifris Scholarships.
</p>